import React from 'react'

export const AuthContext = React.createContext({
  isAuth: '',
  logout: () => {},
  user: {},
  updateUser: () => {}
});